export interface ISvgSize {
  height: number;
  width: number;
}

export type ISvgStartPosition = [number, number]; // x, y

export interface IBaseSvgParams {
  size?: ISvgSize;
  position?: ISvgStartPosition;
  textAnchor?: 'start' | 'middle' | 'end';
}

export type OptionType<TValue = string, TLabel = TValue> = {
  label: TLabel;
  value: TValue;
  subtitle?: string;
};

export enum SLOTS {
  player = 'player',
  tie = 'tie',
  banker = 'banker',
  playerPair = 'playerPair',
  bankerPair = 'bankerPair',
  playerBonus = 'playerBonus',
  bankerBonus = 'bankerBonus',
  luckySix = 'luckySix',
  luckySeven = 'luckySeven',
  anyPair = 'anyPair',
  perfectPair = 'perfectPair',
}

export const NO_COMMISSION_BET_TYPE = 'bankerNoCommission';

export enum Device {
  Desktop = 'DESKTOP',
  Tablet_Portrait = 'TABLET_PORTRAIT',
  Tablet_Landscape = 'TABLET_LANDSCAPE',
  Mobile = 'MOBILE',
}
